export type GraduationUserStatus = "trained" | "eligible" | "in_progress";

export enum GraduationStatusLabel {
    validated = "Validé",
    trained = "Formé",
    eligible = "Éligible promotion",
    in_progress = "En cours",
    in_progress_detailed = "En cours de progression",
}

export type GraduationMainBlocker =
    | "none"
    | "sessions"
    | "day_win"
    | "funding"
    | "method";

export type GraduationNextActionType = "trades" | "payouts" | "none";
export type GraduationSortBy = "score" | "role" | "status";
export type GraduationSortOrder = "asc" | "desc";
export type GraduationMainBlockerFilter = Exclude<
    GraduationMainBlocker,
    "method"
>;

export type GraduationUserRow = {
    userId: string;
    firstname?: string | null;
    lastname?: string | null;
    pseudo?: string | null;
    email?: string | null;
    role?: string | null;
    status: GraduationUserStatus;
    eligibility: {
        score: number;
    };
    mainBlocker: GraduationMainBlocker;
    blockers?: string[];
    nextAction?: {
        type: GraduationNextActionType;
        label: string;
    };
    validatedByAdmin?: boolean;
    validatedBy?: {
        adminId: string;
        validatedAt: string;
        updatedAt: string;
    } | null;
};

export type GraduationPagination = {
    page: number;
    limit: number;
    totalPages: number;
    total?: number;
    currentPage?: number;
    total_pages?: number;
};

export type GraduationSummary = {
    total: number;
    trained: number;
    eligible: number;
    in_progress: number;
};

export type GraduationAdminResponse = {
    users: GraduationUserRow[];
    pagination: GraduationPagination;
    summary: GraduationSummary;
};

export type GraduationAdminFiltersInput = {
    page: number;
    limit: number;
    minScore?: number;
    maxScore?: number;
    search?: string;
    role?: string;
    /** UUID de promo, ou `none` pour les membres sans promo. */
    promotionId?: string;
    isActive?: boolean;
    sortBy?: GraduationSortBy;
    sortOrder?: GraduationSortOrder;
    status?: GraduationUserStatus;
    mainBlocker?: GraduationMainBlockerFilter;
    nextAction?: GraduationNextActionType;
};

export type GraduationAdminExportFiltersInput = Omit<
    GraduationAdminFiltersInput,
    "page" | "limit"
>;
